export const ERROR_MESSAGES: Record<string, string> = {
  COURSE_FACULTY_ACCESS_DENIED: 'You do not have permission to view courses from this faculty.',
  GENERAL_ACCESS_DENIED: 'You do not have permission to access this page.',
  USER_SELF_PERMISSION_ACCESS_DENIED: 'You cannot view or modify your own permissions.',
  USER_SELF_DELETE_DENIED: 'You cannot delete your own user account.',
  AUTHENTICATION_FAILED: 'CCS User Account could not be found.',
  DUPLICATE_COURSE_CRITERION: 'The course enrollment criteria already exists.',
  DUPLICATE_PROGRAM_CRITERION: 'The program enrollment criteria already exists.',
  DUPLICATE_REVISION: 'Revision already exists. Please try a different number.',
  RELEASE_DATE_RESTRICTION: 'Action failed due to release date restrictions or insufficient permissions.',
  DUPLICATE_STAFF_ROLE: 'Staff Role already exists.',
  DUPLICATE_AUXILIARY_COURSE: 'Auxiliary course for this LMS course name already exists.',
  STAFF_ROLE_IN_USE: 'This Role is currently being used for a staff role override and cannot be deactivated.',
  DUPLICATE_TUTOR_ROLE: 'Tutor Role already exists.',
  TUTOR_ROLE_IN_USE: 'This Role is currently assigned to a course offering through Manage Tutor Configuration and cannot be deactivated.'
};
